import React from "react";
import {
  ColorFormat,
  CountdownCircleTimer,
} from "react-countdown-circle-timer";

interface BasicCountdownProps {
  durationInSeconds?: number;
  color?: ColorFormat;
  trailColor?: ColorFormat;
  rotation?: "clockwise" | "counterclockwise" | undefined;
  isPlaying?: boolean;
  isGrowing?: boolean;
  counterSize?: number;
  strokeWidth?: number;
  trailStrokeWidth?: number;
  strokeLinecap?: "round" | "square" | "butt" | undefined;
  initialRemainingTime?: number;
  updateInterval?: number;
  delay?: number;
  shouldRepeat?: boolean;
  customChildStyle?: string;
  onComplete?: () => void;
  key?: string;
}

const BasicCountdown = ({
  durationInSeconds = 10,
  color = "#38a7b4",
  trailColor,
  rotation = "clockwise",
  isPlaying = true,
  isGrowing = false,
  counterSize,
  strokeWidth,
  trailStrokeWidth,
  strokeLinecap = "round",
  initialRemainingTime,
  updateInterval = 0,
  delay,
  shouldRepeat = false,
  customChildStyle = "text-[20px] font-bold",
  key,
  onComplete,
}: BasicCountdownProps) => {
  const formatTime = ({ remainingTime }: { remainingTime: number }) => {
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");
    return (
      <p className={customChildStyle}>
        {formattedMinutes}:{formattedSeconds}
      </p>
    );
  };

  return (
    <CountdownCircleTimer
      key={key}
      duration={durationInSeconds}
      colors={color}
      trailColor={trailColor}
      rotation={rotation}
      isPlaying={isPlaying}
      isGrowing={isGrowing}
      size={counterSize}
      strokeWidth={strokeWidth}
      trailStrokeWidth={trailStrokeWidth}
      strokeLinecap={strokeLinecap}
      initialRemainingTime={initialRemainingTime}
      updateInterval={updateInterval}
      onComplete={() => {
        onComplete && onComplete();

        return { shouldRepeat, delay };
      }}
    >
      {formatTime}
    </CountdownCircleTimer>
  );
};

export default BasicCountdown;
